var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgReloadIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.07537 0.0546047C7.09424 -0.176066 5.09741 0.329152 3.46436 1.47425C1.83131 2.61934 0.675869 4.32449 0.217623 6.26565C-0.240623 8.20681 0.0302664 10.2487 0.978809 12.0032C1.92735 13.7577 3.48743 15.1026 5.36257 15.7823C7.23771 16.462 9.2972 16.429 11.1497 15.6898C12.4725 15.1618 13.624 14.3 14.4991 13.2007L14.7507 15.1538C14.8036 15.5646 15.1795 15.8547 15.5904 15.8018C16.0012 15.7489 16.2913 15.3729 16.2384 14.9621L15.738 11.078C15.6851 10.6671 15.3091 10.377 14.8983 10.4299L11.0141 10.9303C10.6033 10.9833 10.3132 11.3592 10.3661 11.77C10.419 12.1808 10.795 12.471 11.2058 12.418L13.4301 12.1315C12.7047 13.0926 11.7262 13.8446 10.5937 14.2966C9.08282 14.8996 7.40309 14.9264 5.87373 14.3721C4.34436 13.8177 3.07195 12.7208 2.29832 11.2898C1.52469 9.85884 1.30375 8.19349 1.6775 6.61028C2.05124 5.02707 2.99362 3.63634 4.32554 2.7024C5.65746 1.76846 7.28608 1.3564 8.9019 1.54454C10.5177 1.73267 12.0081 2.50789 13.0898 3.72286C14.1715 4.93783 14.7692 6.50786 14.7692 8.1346C14.7692 8.54881 15.105 8.8846 15.5192 8.8846C15.9334 8.8846 16.2692 8.54881 16.2692 8.13459C16.2692 6.14008 15.5364 4.21507 14.2101 2.72542C12.8838 1.23576 11.0565 0.285275 9.07537 0.0546047Z",
    fill: "#3030AD"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgReloadIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/reloadIcon.abf4f44c2514821f1fa05447c005b44a.svg";